import '../../client.css';

const NoContracts = () => (
  <div className="container content-center content-info">
    <div className="row">
      <div className="col-12 cont-icon-info">
        <label className="icon-info-client">&#59671;</label>
      </div>
      <div className="col-12">
        <label className="text-title-info">Aún no se ha registrado ningún contrato</label>
      </div>
      <div className="col col-md-4">&nbsp;</div>
      <div className="col-12 col-md-4">
        <label className="text-info">Aquí podrás visualizar los contratos que estén asociados a este cliente.</label>
      </div>
      <div className="col col-md-4">&nbsp;</div>
    </div>
  </div>
);

export default NoContracts;
